<template>
  <div>
      <div class="ibox float-e-margins">
          <v-select
            :options="countries"
            v-model="selectedCountry"
            @change="loadBrandsForCountry"
            index="country_iso_code"
            label="location_name"
            placeholder="Country">
          </v-select>
          <v-select
            class="m-t-sm"
            v-if="selectedCountry"
            v-model="selectedBrand"
            :options="brandsForSelectedCountry"
            label="brand"
            placeholder="Brand"
          >
        </v-select>
        <v-select
          class="m-t-sm"
          v-if="selectedBrand"
          v-model="selectedAffiliateLink"
          :options="affiliateLinksForSelectedBrand"
          label="affiliateLink"
          placeholder="Affiliate Link"
        >
          <template #option="option">
            <span v-if="option.website">{{ option.website }} - </span>
            {{ option.bonusText }}  ({{ option.affiliateLink }})
          </template>
        </v-select>

          <button class="btn btn-sm m-t-sm btn-primary" @click="addToDraggableList">Add To List</button>
          <div v-for="entry in sortedBrands" :key="entry.country">
            <h3>{{ getCountryName(entry.country) }}</h3>
            <div class="header-item">
              Position - Brand - Bonus - Affiliate Link
            </div>
              <draggable v-model="entry.brands" @end="updateOrder(entry.brands,entry.country)">
                <div v-for="(brand, index) in entry.brands" :key="brand.name" class="draggable-item">
                <div class="position-number">{{ index + 1 }}</div>
                <div class="brand-content">
                  {{ brand.name }} - {{ brand.bonusText }} - {{ brand.affiliateLink }}
                </div>
                  <i class="fa fa-trash delete-icon" @click="deleteBrand(entry.country, brand.linkId)"></i>
                </div>
              </draggable>
          </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import draggable from 'vuedraggable'
import countries from '../../../../../../static/countries.json'
import countryMixin from '../../../../../mixins/countryMixin'
import { TOPLIST_SET } from '../../../../../store/mutation-types'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      selectedCountry: null,
      brandsForSelectedCountry: [],
      selectedBrand: null,
      affiliateLinksForSelectedBrand: [],
      selectedAffiliateLink: null,
      countries: [{ country_iso_code: 'GL', location_name: 'Global' },
        ...countries
      ]
    }
  },
  components: {
    draggable
  },
  computed: {
    ...mapGetters({
      toplist: 'getToplist'
    }),
    sortedBrands () {
      if (this.toplist && this.toplist.entries) {
        return this.toplist.entries.map(entry => {
          return {
            ...entry,
            brands: [...entry.brands].sort((a, b) => a.position - b.position)
          }
        })
      }
    }
  },
  watch: {
    selectedCountry () {
      this.selectedBrand = null
      this.selectedAffiliateLink = null
      this.loadBrandsForCountry()
    },
    selectedBrand (newVal) {
      if (newVal) {
        this.selectedAffiliateLink = null
        this.affiliateLinksForSelectedBrand = newVal.affiliateLinks
      } else {
        this.affiliateLinksForSelectedBrand = []
      }
    }
  },
  mixins: [countryMixin],
  methods: {
    async loadBrandsForCountry () {
      if (!this.selectedCountry) {
        this.brandsForSelectedCountry = []
        return
      }
      try {
        let resp = await axios.get(`/advertisers/brands/`, { params: { country: this.selectedCountry } })
        this.brandsForSelectedCountry = resp.data
      } catch (error) {
        this.selectedBrand = null
        this.$toastr.error('Failed loading lists', error)
      }
    },
    async updateOrder (brands, country) {
      for (let i = 0; i < brands.length; i++) {
        let brand = brands[i]
        brand.position = i + 1
        try {
          const data = {
            country: country,
            advertiserId: brand.advertiserId,
            linkId: brand.linkId,
            position: brand.position
          }
          let resp = await axios.put(`/advertisers/toplists/${this.toplist.id}`, data)
          this.$store.commit(TOPLIST_SET, resp.data)
        } catch (error) {
          console.error(`Error updating position for brand ${brand.name}:`, error)
        }
      }
    },
    async deleteBrand (countryCode, linkId) {
      try {
        let resp = await axios.delete(`/advertisers/toplists/${this.toplist.id}/${linkId}/${countryCode}`)
        this.$store.commit(TOPLIST_SET, resp.data)
        this.$toastr.success('Country deleted successfully')
      } catch (error) {
        this.$toastr.error('Failed deleting country', error)
      }
    },
    async addToDraggableList () {
      if (!this.selectedCountry || !this.selectedBrand || !this.selectedAffiliateLink) {
        this.$toastr.error('Please select a country, brand, and affiliate link before adding.')
        return
      }
      const payload = {
        country: this.selectedCountry,
        advertiserId: this.selectedBrand._id.$oid,
        linkId: this.selectedAffiliateLink._id.$oid
      }
      // calculate position based on the current list's length
      const currentList = this.toplist.entries.find(entry => entry.country === this.selectedCountry)
      payload.position = currentList ? currentList.brands.length + 1 : 1
      try {
        let resp = await axios.put(`/advertisers/toplists/${this.toplist.id}`, payload)
        this.$store.commit(TOPLIST_SET, resp.data)
        this.$toastr.success('Successfully added to list')
        this.selectedBrand = null
        this.selectedAffiliateLink = null
      } catch (error) {
        this.$toastr.error('Failed to add to list', error)
      }
    }
  }
}
</script>
<style>
.draggable-item {
    border: 1px solid #e0e0e0;
    padding: 10px;
    margin-bottom: 5px;
    background-color: #f9f9f9;
    display: flex;
    align-items: center;
}

.draggable-item:hover {
    cursor: move;
    background-color: #f0f0f0;
}

.position-number {
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    background-color: #1ab394;
    color: #fff;
}
.brand-content {
    flex-grow: 1;
    margin-right: 10px;
}

.delete-icon {
    cursor: pointer;
    color: #8f0d0d;
    margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/Toplist/Tabs/Toplist.vue